const Language = {
  ENGLISH: "en_US",
  PORTUGUESE: "pt_BR",
  SPANISH: "es_MX",
  CHINESE: "zh_CN",
  FRENCH: "fr_CA",
  GERMAN: "de_DE",
  ITALIAN: "it_IT",
  POLISH: "pl_PL",
};
export default Language;
